import { render, staticRenderFns } from "./LiveSearch.vue?vue&type=template&id=d4a0b9b6&scoped=true"
import script from "./LiveSearch.js?vue&type=script&lang=js&external"
export * from "./LiveSearch.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a0b9b6",
  null
  
)

export default component.exports